<agpr-take-over-panel
    [id]="'generateReportDialog'"
    [header]="header"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    (visibleChange)="close($event)"
    [width]="80"
>
    @if (currentContentType !== generateReportContentTypes.exportingPDF) {
        <div class="agpr-generateReportDialog-container">
            <!-- default generate report page -->
            @if (currentContentType === generateReportContentTypes.default || selectedTabIndex === generateReportTabTypes.exportPDF) {
                <div class="agpr-generateReportDialog-inner">
                    <h3 class="agpr-headerH3-dark agpr-chartSetupDialog-chartsContainer-title">
                        {{'Reports.sharedReportSetupDialog.reportSettings' | localize}}
                    </h3>
                    <div class="agpr-generateReportDialog-tabs">
                        <div class="agpr-generateReportDialog-tabs-radio">
                            <agpr-radio
                                [id]="'emailContactRadioButton.exportPDF'"
                                [value]="generateReportTabTypes.exportPDF"
                                label="Reports.generateReports.exportPDF"
                                hiddenLabel="generateReportDialog.exportPDF"
                                [(ngModel)]="selectedTabIndex"
                                (ngModelChange)="selectedTabChange(generateReportTabTypes.exportPDF)"
                            ></agpr-radio>
                        </div>
                        <agpr-radio
                            [id]="'emailContactRadioButton.sharedReport'"
                            [value]="generateReportTabTypes.sharedReport"
                            label="Reports.generateReports.interactiveSharedReport"
                            hiddenLabel="generateReportDialog.interactiveSharedReportTab"
                            [(ngModel)]="selectedTabIndex"
                            (ngModelChange)="selectedTabChange(generateReportTabTypes.sharedReport)"
                        ></agpr-radio>
                    </div>
                    <div
                        class="agpr-generateReportDialog-form-input agpr-generateReportDialog-form-input-date"
                    >
                        <agpr-dropdown
                            [id]="'sharedReports_dateFormat'"
                            [label]="'Reports.sharedReportSetupDialog.report.dateFormat'"
                            [options]="dateFormatOptions"
                            [bindToValue]="true"
                            [(ngModel)]="sharedReport.dateFormat"
                            (ngModelChange)="updateReportName()"
                        ></agpr-dropdown>
                    </div>
                    @if (selectedTabIndex === generateReportTabTypes.sharedReport) {
                        <div class="agpr-generateReportDialog-form-input">
                            <agpr-text-input
                                maxLength="64"
                                label="Reports.sharedReportSetupDialog.report.name"
                                [placeholder]="'Reports.sharedReportSetupDialog.report.name.placeholder'"
                                [id]="'sharedReports.reportTitleTextInput'"
                                [(ngModel)]="sharedReport.name"
                                [required]="true"
                                (ngModelChange)="reportTitleChanged($event)"
                                ariaLabel="Reports.sharedReportSetupDialog.report.name"
                            ></agpr-text-input>
                            <agpr-form-message *ngIf="titleEmpty" [id]="'generateReportDialog.formInput.titleEmpty'">
                                {{ 'Reports.sharedReportSetupDialog.report.name.required' | localize}}
                            </agpr-form-message>
                            <agpr-form-message *ngIf="duplicateTitle" [id]="'generateReportDialog.formInput.duplicateTitle'">
                                {{ 'Reports.sharedReportSetupDialog.report.name.duplicated' | localize}}
                            </agpr-form-message>
                        </div>
                    }
                    <agpr-panel
                            class="agpr-generateReportDialog-form-title"
                            header="Cover Page"
                            [toggleable]="false"
                            [contentPadding]="false"
                            [paddingBottom]="0"
                            [required]="true"
                        >
                            <div class="agpr-generateReportDialog-form-coverPage">
                                <div class="agpr-generateReportDialog-form-input agpr-generateReportDialog-form-title">
                                    <agpr-text-input
                                        maxLength="64"
                                        [placeholder]="'Reports.sharedReportSetupDialog.report.title.placeholder'"
                                        [id]="'sharedReports.reportTitleTextInput'"
                                        [(ngModel)]="sharedReport.coverTitle"
                                        label="Reports.sharedReportSetupDialog.report.title"
                                        (ngModelChange)="reportCoverTitleChanged($event)"
                                        [required]="true"
                                        ariaLabel="Reports.sharedReportSetupDialog.report.title"
                                    ></agpr-text-input>
                                    <agpr-form-message *ngIf="coverTitleEmpty" [id]="'generateReportDialog.formInput.coverTitleEmpty'">
                                        {{ 'Reports.sharedReportSetupDialog.report.title.required' | localize}}
                                    </agpr-form-message>
                                </div>
                                <div class="agpr-generateReportDialog-form-image">
                                    <agpr-file-upload #fileUpload
                                        [id]="'sharedReports.imageUpload'"
                                        header="Reports.sharedReportSetupDialog.report.coverPageImage.header"
                                        [uppercaseHeader]="false"
                                        [uploadButtonLabel]="''"
                                        placeholder="Reports.sharedReportSetupDialog.report.coverPageImage.placeholder"
                                        [holdFileData]="true"
                                        [useContentLibraryUpload]="true"
                                        [uploadButtonIcon]="'fa-regular fa-duotone fa-square-plus'"
                                        [supportedFileTypesRegex]="imageMIMETypesRegex"
                                        [supportedFileTypes]="imageMIMETypes"
                                        [maxFiles]="1"
                                        [(ngModel)]="coverImage"
                                        [shownoContentIcon]="false"
                                        (uploadButtonClick)="openContentLibrary()"
                                    ></agpr-file-upload>
                                </div>
                            </div>
                    </agpr-panel>
                </div>
                <div class="agpr-generateReportDialog-inner agpr-generateReportDialog-inner-charts">
                    <h3 class="agpr-headerH3-dark agpr-chartSetupDialog-chartsContainer-title">
                        {{'Reports.chartSetupDialog.chartsLabel' | localize}}
                    </h3>
                    <agpr-scroll-panel>
                        <div class="agpr-generateReportDialog-container">
                            <div class="agpr-generateReportDialog-chartList">
                                <ul
                                    id="sharedReports_chartList"
                                    agprListKeyboardNavigation
                                    [list]="charts"
                                >
                                    <li
                                        class="agpr-generateReportDialog-chartList-chart agpr-contextMenu-parent"
                                        *ngFor="let chart of charts; index as i"
                                        [ngClass]="{'agpr-generateReportDialog-chartList-chart--active': activeChart && activeChart.displayElement.index == chart.displayElement.index }"
                                        [attr.aria-label]="chart.displayElement?.title | localize"
                                    >
                                        <div (click)="enableEditingNote(activeChart.displayElement.index == chart.displayElement.index, chart)" class="agpr-generateReportDialog-chartList-chart-inner">
                                            <div class="agpr-contextMenu top right">
                                                @if (chart.displayElement.enableEditingNote) {
                                                    <agpr-button
                                                        [icon]="'fa-regular fa-duotone fa-square-minus'"
                                                        (click)="enableEditingNote(false, chart)"
                                                        [disabled]="prominenceStatus !== prominenceStatuses.DONE
                                                            && (chart.type.key === reportBlockTypeEnum.PROMINENCE_OVER_TIME || chart.type.key === reportBlockTypeEnum.PROMINENCE_BY_REACH)"
                                                        [tooltip]="((prominenceStatus !== prominenceStatuses.DONE && (chart.type.key === reportBlockTypeEnum.PROMINENCE_OVER_TIME || chart.type.key === reportBlockTypeEnum.PROMINENCE_BY_REACH))
                                                            ? 'Reports.sharedReportSetupDialog.charts.disabled.tooltop' : 'Reports.sharedReportSetupDialog.charts.minusIcon.tooltip') | localize"
                                                        tooltipPosition="top"
                                                        [style]="buttonTypes.contextMenu"
                                                    ></agpr-button>
                                                } @else {
                                                    <agpr-button
                                                        [icon]="'fa-regular fa-duotone fa-square-plus'"
                                                        (click)="enableEditingNote(true, chart)"
                                                        [disabled]="prominenceStatus !== prominenceStatuses.DONE
                                                            && (chart.type.key === reportBlockTypeEnum.PROMINENCE_OVER_TIME || chart.type.key === reportBlockTypeEnum.PROMINENCE_BY_REACH)"
                                                        [tooltip]="((prominenceStatus !== prominenceStatuses.DONE && (chart.type.key === reportBlockTypeEnum.PROMINENCE_OVER_TIME || chart.type.key === reportBlockTypeEnum.PROMINENCE_BY_REACH))
                                                            ? 'Reports.sharedReportSetupDialog.charts.disabled.tooltop' : 'Reports.sharedReportSetupDialog.charts.plusIcon.tooltip') | localize"
                                                        tooltipPosition="top"
                                                        [style]="buttonTypes.contextMenu"
                                                    ></agpr-button>
                                                }
                                                <agpr-button
                                                    [disabled]="i == 0"
                                                    icon="fa-regular fa-arrow-up"
                                                    (click)="moveChartUp(i)"
                                                    tooltip="Reports.sharedReportSetupDialog.charts.moveUp"
                                                    tooltipPosition="top"
                                                    [style]="buttonTypes.contextMenu"
                                                ></agpr-button>
                                                <agpr-button
                                                    [disabled]="i == charts.length - 1"
                                                    icon="fa-regular fa-arrow-down"
                                                    (click)="moveChartDown(i)"
                                                    tooltip="Reports.sharedReportSetupDialog.charts.moveDown"
                                                    tooltipPosition="top"
                                                    [style]="buttonTypes.contextMenu"
                                                ></agpr-button>
                                            </div>
                                            <div class="agpr-generateReportDialog-chartList-chart-chartCard">
                                                <agpr-chart-card
                                                    [chart]="chart"
                                                    [dateFormat]="sharedReport.dateFormat"
                                                    (click)="setActiveChart(chart)"
                                                    [selected]="activeChart && activeChart.displayElement.index == chart.displayElement.index"
                                                ></agpr-chart-card>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </agpr-scroll-panel>
                </div>
            }
            <!-- invite recipients form -->
            @if (currentContentType === generateReportContentTypes.sendInvites && selectedTabIndex === generateReportTabTypes.sharedReport) {
                <agpr-scroll-panel class="agpr-generateReportDialog-inviteRecipientScrollPanel">
                    <agpr-panel
                        [header]="'Reports.sharedReportInviteDialog.panel' | localize:{name: sharedReport.name}"
                        class="agpr-generateReportDialog-inviteRecipientPanel"
                        [toggleable]="false"
                        [contentPadding]="false"
                    >
                        <div class="agpr-generateReportDialog-formInput">
                            <div class="agpr-inputGroup">
                                <label for="mailingLists.picker" class="agpr-generateReportDialog-inputLabel">
                                    {{ 'Reports.sharedReportInviteDialog.report.mailingLists' | localize }}
                                </label>
                                <agpr-mailing-list-picker
                                    [(ngModel)]="sharedReport.mailingListIds"
                                    (ngModelChange)="checkRecipients()"
                                ></agpr-mailing-list-picker>
                            </div>
                            <div class="agpr-inputGroup">
                                <agpr-email-chips
                                    id="shareReport.recipientList"
                                    [(value)]="sharedReport.recipientList"
                                    [placeholder]="'Reports.sharedReportInviteDialog.report.recipients.placeholder'"
                                    (valueChange)="checkRecipients()"
                                    [errorKey]="'invalidEmailFormat' | localize"
                                    [showDuplicateErrorKey]="'Common.forms.email.duplicateEmail'"
                                    [header]="'Reports.sharedReportInviteDialog.report.recipients'"
                                ></agpr-email-chips>
                            </div>
                            <div class="agpr-inputGroup">
                                <agpr-text-input
                                    [id]="'fromName'"
                                    label="Reports.sharedReportInviteDialog.report.fromName"
                                    [placeholder]="'Reports.sharedReportInviteDialog.report.fromName.placeholder'"
                                    [bottomMargin]="false"
                                    [(ngModel)]="sharedReport.fromName"
                                ></agpr-text-input>
                            </div>
                            <div class="agpr-inputGroup">
                                <agpr-text-input
                                    [id]="'replyEmail'"
                                    label="Reports.sharedReportInviteDialog.report.replyTo"
                                    [placeholder]="'Reports.sharedReportInviteDialog.report.replyTo.placeholder'"
                                    [bottomMargin]="false"
                                    [(ngModel)]="sharedReport.replyTo"
                                    (blur)="validateReplyTo()"
                                ></agpr-text-input>
                                <agpr-form-message *ngIf="invalidReplyTo" [id]="'generateReportDialog.formInput.invalidReplyTo'">
                                    {{ 'invalidEmailFormat' | localize }}
                                </agpr-form-message>
                            </div>
                            <div class="agpr-inputGroup">
                                <agpr-textarea-input
                                    id="inviteMessage"
                                    label="Reports.sharedReportInviteDialog.report.inviteMessage"
                                    [(ngModel)]="sharedReport.inviteMessage"
                                    (ngModelChange)="checkInputLength($event)"
                                    [placeholder]="'Reports.sharedReportInviteDialog.report.inviteMessage.placeholder'"
                                    [maxLength]="maxInputLength"
                                    [rows]="4"
                                ></agpr-textarea-input>
                            </div>
                            <agpr-form-message *ngIf="recipientsEmpty" [id]="'generateReportDialog.formInput.recipientsEmpty'">
                                {{ 'Reports.sharedReportInviteDialog.report.recipients.validation' | localize }}
                            </agpr-form-message>
                            <agpr-form-message *ngIf="inputLengthExceeding" [id]="'generateReportDialog.formInput.inputLengthExceeding'">
                                {{ 'Reports.sharedReportInviteDialog.report.inviteMessage.maxLength' | localize }}
                            </agpr-form-message>
                        </div>
                    </agpr-panel>
                </agpr-scroll-panel>
            }
        </div>
    }

    <!-- exporting progress page -->
    @if (currentContentType === generateReportContentTypes.exportingPDF) {
        <div
        class="agpr-generateReportDialog-exportingContent"
        >
            <span class="agpr-i-line-reports agpr-generateReportDialog-exportingIcon" aria-hidden="true"></span>
            <div>
                <span class="agpr-generateReportDialog-exportingDescription">{{ 'Reports.generateReports.exportingDescription' | localize }}</span>
                <span class="agpr-generateReportDialog-exportingDescription agpr-generateReportDialog-exportingDescription--bold">{{ exportingStatusString | localize }}</span>
            </div>
            <div class="agpr-generateReportDialog-exportingProgressBar">
                <p-progressBar
                    [value]="((progress?.currentIndex / progress?.totalItems) * 100)"
                    [showValue]="false"
                ></p-progressBar>
            </div>
            <div class="agpr-generateReportDialog-exportingStatus">
                <span>
                    {{ progress?.currentIndex }} / {{ progress?.totalItems }}
                </span>
            </div>
        </div>
    }
    <ng-template #takeOverFooterLeft>
        <agpr-button
            label="Core.button.cancel"
            id="generateReportDialog.cancelButton"
            [style]="buttonTypes.secondary"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #takeOverFooterRight>
        <agpr-button
            *ngIf="selectedTabIndex === generateReportTabTypes.sharedReport && currentContentType === generateReportContentTypes.default"
            id="generateReportDialog.nextStep"
            [label]="sharedReport.id ? 'Reports.sharedReportEditDialog.update' : 'Reports.sharedReportSetupDialog.heading'"
            [style]="buttonTypes.primary"
            [loading]="saveLoading"
            [disabled]="sharedReport.charts.length === 0 || titleEmpty || coverTitleEmpty || duplicateTitle"
            (click)="sharedReport.id ? updateSharedReport() : createSharedReport()"
        ></agpr-button>
        <agpr-button
            *ngIf="selectedTabIndex === generateReportTabTypes.exportPDF && currentContentType !== generateReportContentTypes.exportingPDF"
            id="generateReportDialog.exportPDF"
            label="Reports.generateReports.createPdfReport"
            [style]="buttonTypes.primary"
            [loading]="saveLoading || uploadingCoverImage"
            [disabled]="sharedReport.charts.length === 0 || uploadingCoverImage || coverTitleEmpty"
            (click)="exportPDF()"
        ></agpr-button>
        <agpr-button
            *ngIf="selectedTabIndex === generateReportTabTypes.sharedReport && currentContentType === generateReportContentTypes.sendInvites"
            id="generateReportDialog.skip"
            label="Reports.sharedReportInviteDialog.skip"
            [style]="buttonTypes.primary"
            (click)="cancel()"
        ></agpr-button>
        <agpr-button
            *ngIf="selectedTabIndex === generateReportTabTypes.sharedReport && currentContentType === generateReportContentTypes.sendInvites"
            id="generateReportDialog.actionButton"
            label="Reports.sharedReportInviteDialog.send"
            [style]="buttonTypes.primary"
            [loading]="shareLoading"
            (click)="sendInvites()"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
